import apiRoutes from 'router/routes/ApiRoutes';

import FetchHelpers from 'utils/FetchHelpers';

export default {
  async show(params) {
    const url = apiRoutes.configurationBloombergPath();
    return FetchHelpers.get(url, params);
  },
  async update(params) {
    const url = apiRoutes.configurationBloombergPath();
    return FetchHelpers.put(url, params);
  },
};
